/**
 * CSS Variable constants for EventComponent theming
 * Provides type-safe access to CSS custom properties
 *
 * These constants prevent typos and provide autocomplete when working with CSS variables.
 * All variant-specific styling is controlled through these CSS variables,
 * allowing "dumb" styled components that consume them.
 */
export const EVENT_CSS_VARS = {
  // Color variables
  color: {
    bg: '--event-color-bg',
    text: '--event-color-text',
    border: '--event-color-border', // Used for both outline and left border
    accent: '--event-color-accent',
  },
  // Outline variables (used for main border around event)
  outline: {
    width: '--event-outline-width',
    style: '--event-outline-style',
  },
  // Left border variables (used for accent stripe on actionable events)
  borderLeft: {
    width: '--event-border-left-width',
  },
  // Shadow variables
  shadow: '--event-shadow',
  // Expanded card specific
  expanded: {
    outline: {
      width: '--event-expanded-outline-width',
      style: '--event-expanded-outline-style',
    },
    shadow: '--event-expanded-shadow',
  },
} as const;

// Type helper for CSS variable values
export type CSSVarValue = string | number;
